import { ReactNode } from "react";
import { FieldRenderProps } from "react-final-form";
import cx from "classnames";

import styles from "./InputWrapper.scss";

type InputProps = FieldRenderProps<any, HTMLInputElement>["input"];
type MetaProps = FieldRenderProps<any, HTMLInputElement>["meta"];

type InputWrapperProps = {
  children?: ReactNode;
  input: InputProps;
  meta: MetaProps;
  sideSymbol?: () => ReactNode;
  customStyles?: string;
  isDisabled?: boolean;
};

const InputWrapper = ({
  children,
  input,
  meta,
  sideSymbol,
  isDisabled = false,
  customStyles = ""
}: InputWrapperProps) => (
  <div className={cx(styles.inputWrapper, { [styles.disabled]: isDisabled }, customStyles)}>
    {children}
    {sideSymbol && (
      <div
        className={cx({
          [styles.sideSymbol]: true,
          [styles["sideSymbol--active"]]:
            (meta && meta.active) || (input && input.value && !!input.value.length)
        })}
        data-testid="sidesymbol"
      >
        {sideSymbol()}
      </div>
    )}
  </div>
);

export default InputWrapper;
